var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BidAwardRevokeReasonService, } from '@freelancer/bid-award-revoke-reason-service';
import { Datastore, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';
import { maxLength, required } from '@freelancer/ui/validators';
import { BidAwardStatusApi } from 'api-typings/projects/projects';
import { map, take, withLatestFrom } from 'rxjs/operators';
var RevokeModalError;
(function (RevokeModalError) {
    RevokeModalError[RevokeModalError["REVOKE_FAILED"] = 0] = "REVOKE_FAILED";
})(RevokeModalError || (RevokeModalError = {}));
var CloseProjectModalComponent = /** @class */ (function () {
    function CloseProjectModalComponent(datastore, fb, modalRef, revokeReasonService, router) {
        this.datastore = datastore;
        this.fb = fb;
        this.modalRef = modalRef;
        this.revokeReasonService = revokeReasonService;
        this.router = router;
        this.BannerAlertType = BannerAlertType;
        this.ButtonColor = ButtonColor;
        this.TextSize = TextSize;
        this.HeadingType = HeadingType;
        this.Margin = Margin;
        this.RevokeModalError = RevokeModalError;
        this.OTHER_REASON = 'Other';
        this._isRevoked = false;
    }
    CloseProjectModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.fb.group({
            reason: ['', [required('Please select a reason')]],
            otherReason: '',
        });
        var revokeReasons$ = this.datastore
            .collection('bidAwardRevokeReasons')
            .valueChanges();
        this.closeProjectReasons$ = revokeReasons$.pipe(map(function (reasons) { return [
            ''
        ].concat(reasons.map(function (reason) { return ({
            displayText: reason.reason,
            value: reason.reason,
        }); })); }));
        this.revokeReasonMap$ = revokeReasons$.pipe(map(function (reasons) {
            return reasons.reduce(function (acc, reason) {
                acc[reason.reason] = reason.id;
                return acc;
            }, {});
        }));
        this.bidDocument = this.datastore.document('bids', this.bidId);
        this.formSubscription = this.formGroup.controls.reason.valueChanges.subscribe(function (form) {
            var otherReasonControl = _this.formGroup.controls.otherReason;
            otherReasonControl.setValidators([]);
            otherReasonControl.reset();
            if (form === _this.OTHER_REASON) {
                otherReasonControl.setValidators([
                    required('Please enter a reason'),
                    maxLength(100, 'Please enter at most 100 characters'),
                ]);
            }
            otherReasonControl.updateValueAndValidity();
        });
    };
    CloseProjectModalComponent.prototype.ngOnDestroy = function () {
        if (this.formSubscription) {
            this.formSubscription.unsubscribe();
        }
    };
    CloseProjectModalComponent.prototype.closeModal = function () {
        this.modalRef.close();
    };
    /**
     *
     * Two separate API calls
     * 1. Revoke the bid award
     * 2. Save the revoke reason
     *
     * The first request is more important, so we only send the second request
     * if the first one is successful.
     *
     */
    CloseProjectModalComponent.prototype.handleRevokeAward = function () {
        var _this = this;
        // allow employer to only re-submit revoke reason if the request failed
        if (this._isRevoked) {
            this.submissionPromise = this.bidDocument
                .valueChanges()
                .pipe(take(1), withLatestFrom(this.revokeReasonMap$))
                .toPromise()
                .then(function (_a) {
                var bid = _a[0], reasonMap = _a[1];
                return _this.createBidAwardRevokeReasonRecord(bid, _this.formGroup, reasonMap);
            })
                .then(function (bidRevokeReasonResponse) {
                _this.closeModal();
                return bidRevokeReasonResponse;
            });
        }
        else {
            var reasonMap_1;
            var bid_1;
            this.submissionPromise = this.bidDocument
                .valueChanges()
                .pipe(take(1), withLatestFrom(this.revokeReasonMap$))
                .toPromise()
                .then(function (_a) {
                var bidTemp = _a[0], reasonMapTemp = _a[1];
                reasonMap_1 = reasonMapTemp;
                bid_1 = bidTemp;
                return _this.bidDocument.update({
                    awardStatus: BidAwardStatusApi.REVOKED,
                });
            })
                .then(function (bidRevokeResponse) {
                if (bidRevokeResponse.status === 'error') {
                    return __assign({ errorType: RevokeModalError.REVOKE_FAILED }, bidRevokeResponse);
                }
                _this._isRevoked = true;
                return _this.createBidAwardRevokeReasonRecord(bid_1, _this.formGroup, reasonMap_1);
            })
                .then(function (bidRevokeReasonResponse) {
                _this.closeModal();
                _this.router.navigate(["/projects/" + _this.project.seoUrl + "/details"]);
                return bidRevokeReasonResponse;
            });
        }
    };
    CloseProjectModalComponent.prototype.createBidAwardRevokeReasonRecord = function (bid, formGroup, reasonMap) {
        var reasonId = reasonMap[formGroup.controls.reason.value];
        var otherFeedback = formGroup.controls.reason.value === this.OTHER_REASON
            ? formGroup.controls.otherReason.value
            : '';
        return this.revokeReasonService.saveBidAwardRevokeReason({
            projectId: bid.projectId,
            freelancerId: bid.bidderId,
            reasonId: reasonId,
            otherFeedback: otherFeedback,
        });
    };
    return CloseProjectModalComponent;
}());
export { CloseProjectModalComponent };
